// SettingsTab — thin delegation to SettingsLayout.
//
// The old monolithic SettingsTab was split into per-section components
// under pages/dashboard/settings/, mirroring the AccountTab → AccountLayout
// pattern. Layout (left rail on md+, top dropdown on mobile) and nested
// routing live in SettingsLayout.
//
// Routes registered by SettingsLayout:
//   /settings/tracking      — JS embed snippet
//   /settings/verification  — domain ownership verification
//   /settings/bots          — per-bot allow / block
//   /settings/llms-txt      — llms.txt serving + content
//   /settings/autopilot     — AutoPilot recurring audit schedule
import SettingsLayout from './settings/SettingsLayout';

export default function SettingsTab({ domain }) {
  return <SettingsLayout domain={domain} />;
}
